import Vue from "vue"
import Router from "vue-router"
import Home from "./views/Home"
import Welcome from "./views/Welcome"
import Dashboard from "./views/Dashboard"
import Translations from "./views/Translations"
import NotFound from "./views/NotFound"

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
    if (!(localStorage.getItem("apollo-token") || "")) {
        next()
        return
    }
    next("/")
}

const ifAuthenticated = (to, from, next) => {
    if (localStorage.getItem("apollo-token") || "") {
        next()
        return
    }
    next("/welcome")
}

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
            beforeEnter: ifAuthenticated
        },
        {
            path: "/welcome",
            name: "welcome",
            component: Welcome,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: "/translations/:language/:dict?",
            name: "translations",
            component: Translations,
            beforeEnter: ifAuthenticated
        },
        {
            path: "/dashboard",
            name: "dashboard",
            component: Dashboard,
            beforeEnter: ifAuthenticated
        },
        {
            path: "*",
            name: "notfound",
            component: NotFound
        }
    ]
})
